import Vue from 'vue';
import Component from 'vue-class-component';
import Moment from 'moment';
import { _SCHOOL_CALENDAR_STORE, SCHOOL_DAY_STATUS, SCHOOL_DATE_TYPE, SCHOOL_DAYS_EVENTS } from '@/tools/values/school-calendar.values';
import { WEEK_DAYS } from '@/values/general.values';
import KEYS from '@/values/keys';
import { Holiday } from '@/tools/models/holiday.model';
import { Status } from '@/models/status.model';
import { ICreateSchoolDayModalParams } from '@/tools/interfaces/create-school-day-modal-params.interface';
import EdSchoolCalendar from '@/core/components/ed-school-calendar/ed-school-calendar.component.vue';
import EdCreateSchoolDay from '@/tools/components/ed-create-school-day/ed-create-school-day.component.vue';
import { SCHOOL_CALENDAR_STORE } from '@/tools/store/school-calendar.store';
import EdInputModel from '@/models/ed-input.model';
import { Watch } from 'vue-property-decorator';
import { EdContextMenuModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';


@Component({
  name: 'ed-institution-calendar',
  components: {
    EdSchoolCalendar
  }
})
export default class EdInstitutionCalendarComponent extends Vue {

  public status: Status = new Status();
  public showNonSchoolDaysInputModel: any = EdInputModel('showNonSchoolDaysInputModel', this.showNonSchoolDays, {}, true);

  get businessDays(): Holiday[] {
    let holidays: Holiday[] = this.$store.state.SchoolCalendarStore.holidays;
    return holidays.filter(h => h.status == SCHOOL_DAY_STATUS.IGNORED);
  }

  get colors() {
    return this.$store.state.SchoolCalendarStore.preferences.colors;
  }

  get showNonSchoolDays() {
    return this.$store.state.SchoolCalendarStore.showNonSchoolDays;
  }

  get workingDaysInput() {
    return this.$store.state.SchoolCalendarStore.workingDays;
  }
  
  get schoolDays() {
    return this.$store.state.SchoolCalendarStore.schooldays;
  }
  
  get weekdays() {
    if(!this.showNonSchoolDays) {
      let workingDays = this.$store.state.SchoolCalendarStore.workingDays;
      let weekdays = [];
      workingDays.forEach((wd, i) => {
        if(wd.checked) weekdays.push(i);
      });
      return weekdays;
    } else {
      return [0, 1, 2, 3, 4, 5, 6];
    }
  }

  get holidays() {
    return this.$store.state.SchoolCalendarStore.holidays;
  }

  get userHasSession() {
    return this.$store.state.AuthStore.hasSession;
  }

  validateSchoolDay(date, schoolDays) {
    let style: any = {};
    if(date !== Moment().format('YYYY-MM-DD')) {

      /* Validate school day */
      let i = schoolDays.findIndex(sd => {
        let found = sd.dates.find(d => {
          return d == date;
        });
        if(found) return true;
      });
      if(i != -1) {
        style.backgroundColor = `${schoolDays[i].color}20 !important`;
      }
      
      /* Validate if the date is in working days or business days */
      let business = this.businessDays.find(b => b.startDate == date);
      if(!business && i == -1) {
        let dayOfWeek = WEEK_DAYS[Moment(date).get('day')];
        let workingDays = this.$store.state.SchoolCalendarStore.workingDays;
        let schoolDay = workingDays.find(wd => {
          return wd.label == dayOfWeek;
        });
        if(schoolDay) {
          if(!schoolDay.checked) {
            style.color = 'var(--ed-color-gray-light-plus)';
          }
        }
      }

    } else {
      style = {
        backgroundColor: `${this.colors.CURRENT_DATE} !important`,
        color: 'white'
      };
    }
    return style;
  }

  validateCurrentDay(date) {
    let style: any = {};
    if(date === Moment().format('YYYY-MM-DD')) {
      style = {
        backgroundColor: `${this.colors.CURRENT_DATE} !important`,
        color: 'white'
      };
    }
    return style;
  }

  openCreateEvent(e, date) {
    let dateSelected = Moment(date);
    let now = Moment();
    if(dateSelected.isSame(now, 'date') || dateSelected > now) {
      this.goToCreateEvent(date);
    } else {
     this.showErrorTryCreating();
    }
  }

  getIsSchoolDay(date, schoolDays) {
    let response = false;
    schoolDays.forEach(calendar => {
      if(calendar.dates.includes(date)) {
        response = true;
      }
    });
    return response;
  }

  getSchoolDay(date, schoolDays) {
    let j = 0;
    let i = schoolDays.findIndex(sd => {
      let found = sd.dates.find(d => {
        return d == date;
      });
      if(found) {
        j = sd.dates.indexOf(found);
        return true;
      }
    });
    return { index: i, day: j }
  }

  goToCreateEvent(date) {
    this.$EdModal.createModal(
      EdCreateSchoolDay,
      {
        date,
        edition: false,
        description: '',
        id: null,
        type: SCHOOL_DATE_TYPE.DAY_OFF,
        endAt: date
      }
    );
  }

  goToEditEvent(event) {
    let isSchoolCalendar = event.type == SCHOOL_DATE_TYPE.SCHOOL_CALENDAR;
    let dates = isSchoolCalendar ? this.getDatesOfSchoolDay(event.id) : event;
    let description = isSchoolCalendar ? event.category : event.name ? event.name : event.label;
    let now = Moment(Moment().format('YYYY-MM-DD'));
    let canContinue = Moment(dates.start).isSame(now, 'date') || Moment(dates.end).isSame(now, 'date') || Moment(dates.end).isAfter(now) || Moment(dates.start).isAfter(now, 'date');
    if(canContinue) {
      const startDate = dates ? dates.start : event.start;
      const endDate = dates ? dates.end : '';
      const date = Moment(startDate).format('YYYY-MM-DD');
      const endAt = Moment(endDate).format('YYYY-MM-DD');

      const params: ICreateSchoolDayModalParams = {
        date,
        edition: true,
        description,
        id: event.id,
        type: event.type,
        status: event.status,
        endAt,
        official: event.official,
      };
      this.$EdModal.createModal(
        EdCreateSchoolDay,
        params
      );
    } else {
      this.showErrorTryCreating();
    }
  }

  getDatesOfSchoolDay(schoolDayId: number) {
    let schooldays = this.$store.state.SchoolCalendarStore.schooldays;
    let period = schooldays.find(sc => sc.schoolDayId == schoolDayId);
    return { 
      start: period.startDate,
      end: period.endDate
    }
  }

  showErrorTryCreating() {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('tools.schooldays.errors.errorSavingDateTitle'),
      body: this.$i18n.t('tools.schooldays.errors.errorTryCreate'),
      type: KEYS.EVENT_TYPES.DANGER
    });
    this.goToPresentDay();
  }

  goToPresentDay() {
    setTimeout(() => {
      let present: any = document.querySelector('.v-calendar-weekly__day.v-present');
      if(present) {
        let top = present.offsetTop - 300;
        document.getElementById('sidebar-body').scrollTop = top
        document.getElementById('school-calendar__content').scrollTop = top
      }
    }, 500);
  }

  updateShowNonSchoolDays(inputModel) {
    let value:boolean = inputModel.value;
    this.$store.commit(SCHOOL_CALENDAR_STORE.MUTATIONS.UPDATE_SHOW_NON_SCHOOL_DAYS, value);
  }

  async refreshCalendar(schoolCalendarData, organizationId : number, isRetryAttempt: boolean = false) {
    try {
      this.status.setLoading();
      await this.$store.dispatch(
        _SCHOOL_CALENDAR_STORE.ACTIONS.GET_SCHOOLDAYS, 
        schoolCalendarData
      );
      await this.$store.dispatch(
        _SCHOOL_CALENDAR_STORE.ACTIONS.GET_HOLIDAYS, 
        schoolCalendarData
      );
      await this.$store.dispatch(
        _SCHOOL_CALENDAR_STORE.ACTIONS.GET_WORKING_DAYS,
        { organizationId }
      );
      await this.$store.dispatch(
        _SCHOOL_CALENDAR_STORE.ACTIONS.GET_COLORS_PREFERENCE,
        organizationId
      );
      await this.$store.dispatch(
        _SCHOOL_CALENDAR_STORE.ACTIONS.GET_SCHOOLDAYS_ACTIVE,
        { organizationId }
      );
      (this.$refs.schoolCalendar as any).createCalendar();
      this.status.setLoad(); 
      this.goToPresentDay();
    } catch(err) {
      // Retry once on undefined error (like 200 - ERR_INCOMPLETE_CHUNKED_ENCODING)
      if (err == undefined && !isRetryAttempt) {
        setTimeout(() => {
          this.refreshCalendar(schoolCalendarData, organizationId, true); // true to avoid infinite retry
        });
        return;
      }

      this.status.setError();
      this.goToPresentDay();
    }
  }

  async saveWorkingDaysAction (data) {
    await this.$store.dispatch(
      _SCHOOL_CALENDAR_STORE.ACTIONS.SAVE_WORKING_DAYS,
      data
    );
  }
  
  refreshCalendarAction() {
    this.$edEventBus.$emit(SCHOOL_DAYS_EVENTS.REFRESH_CALENDAR);
  }

  @Watch('userHasSession')
  private onUserSessionChange() {
    if(this.userHasSession ) {
      this.status.setLoad();
    } else {
      this.status.setLoading();
    }
  }

  private _closeEdContextMenu(): void {
    this.$EdContextMenu.close();
  }

  private _showEdContextMenu(text: string, position: {x: number, y: number}): void {
    this.$EdContextMenu.show(new EdContextMenuModel({
      position: { x: position.x, y: position.y },
      options: [{ text }],
      darkMode: true,
    }));
  }

  public onWcCalendarDayMouseOver(customEvent: CustomEvent): void {
    const date: string = customEvent?.detail?.value?.date;
    const mouseEvent: MouseEvent = customEvent?.detail?.value?.mouseEvent;

    if (!date || !mouseEvent || !this.getIsSchoolDay(date, this.schoolDays)) {
      return;
    }

    const text = `${this.$t('tools.schooldays.schoolDay')}: ${(this.getSchoolDay(date, this.schoolDays).day + 1 )}`;
    const position = {x: mouseEvent.x, y: mouseEvent.y};
    this._showEdContextMenu(text, position);
  }

  public onWcCalendarDayMouseLeave(): void {
    this._closeEdContextMenu();
  }

  public onWcCalendarEventMouseOver(customEvent: CustomEvent): void {
    const eventData = customEvent?.detail?.value?.eventData;
    const mouseEvent: MouseEvent = customEvent?.detail?.value?.mouseEvent;

    if (!eventData || !mouseEvent) {
      return;
    }

    const position = {x: mouseEvent.x, y: mouseEvent.y};
    this._showEdContextMenu(eventData.label, position);
  }

  public onWcCalendarEventMouseLeave(): void {
    this._closeEdContextMenu();
  }

  public onWcCalendarDaySelection(customEvent: CustomEvent): any {
    const date: string = customEvent?.detail?.value;
    if (!date) {
      return;
    }
    this.openCreateEvent(customEvent, date);
  }

  public onWcCalendarEventSelection(customEvent: CustomEvent): void {
    const eventData: any = customEvent?.detail?.value;
    if (!eventData) {
      return;
    }
    this.goToEditEvent(eventData);
  }
}